import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    Check,
    Grade,
} from '../../../split-screen/models/training-prestart-check';

@Component({
    selector: 'app-checks-modal',
    templateUrl: './checks-modal.component.html',
    styleUrls: ['./checks-modal.component.scss'],
    standalone: false,
})
export class ChecksModalComponent implements OnInit {
    errorChecks: Check[] = [];
    hintChecks: Check[] = [];

    constructor(
        public dialogRef: MatDialogRef<ChecksModalComponent, boolean>,
        @Inject(MAT_DIALOG_DATA)
        public injectedData: {
            internationalizationPrefix: string;
            checks: Check[];
        }
    ) {
        this.dialogRef.addPanelClass('container-administration-dialog');
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        this.groupChecksByGrade();
    }

    onClose(triggerStart: boolean) {
        this.dialogRef.close(triggerStart);
    }

    private groupChecksByGrade() {
        this.injectedData.checks.forEach((check: Check) => {
            switch (check.grade) {
                case Grade.HINT:
                    this.hintChecks.push(check);
                    break;
                case Grade.ERROR:
                    this.errorChecks.push(check);
                    break;
            }
        });
    }

    getPlaceholderValues(check: Check): {
        [key: string]: string;
    } {
        const res = {};
        check.data.forEach((val) => {
            res[val.name] = val.value;
        });
        return res;
    }
}
